export function formatFileSize(sizeInBytes) {
    if (sizeInBytes === 0) {
        return '0 Bytes';
    }
    var units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    var unitIndex = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
    var formattedSize = (sizeInBytes / Math.pow(1024, unitIndex)).toFixed(2);
    return "".concat(formattedSize, " ").concat(units[unitIndex]);
}
